module.exports = __webpack_public_path__ + "img/img1.fw.3f7e52f4.png";